import {
  invoiceStartGuideSteps,
  invoiceStartGuideTexts,
} from "EinvoiceProject/InvoiceStartGuide/invoiceStartGuideContent";
import { sgT } from "./translate";

export const invoiceStartGuideContent = {
  texts: invoiceStartGuideTexts,
  steps: invoiceStartGuideSteps,
  followServerOrder: true,
  defaultSteps: [
    { id: "1", step: "1", get name() { return sgT("tax.steps.profile.name"); }, category: "optional", optional: true },
    { id: "subscription", step: "subscription", get name() { return sgT("invoice.steps.subscription"); }, category: "optional", optional: true, skippable: false },
    { id: "2", step: "2", get name() { return sgT("invoice.steps.vatNumber"); }, category: "optional", optional: true },
    { id: "3", step: "3", get name() { return sgT("invoice.steps.peppolNumber"); }, category: "optional", optional: true },
    { id: "4", step: "4", get name() { return sgT("invoice.steps.bankInformation"); }, category: "optional", optional: true, skippable: false },
  ],
};
